import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { IconImg } from '../../Defaults/Icon/IconImg';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { TableTd } from '../../Zemplin/General/Table';
import { CountSetter } from '../Cart/CountSetter';
import { ButtonWithRequest } from './ButtonWithRequest';

interface Props {
  unit: string;
  addToRequest: any;
  addToCart: any;
  handleCountChange: any;
  count: number;
  isAdding?: boolean;
}

function ProductPriceCartTable({
  unit,
  addToCart,
  addToRequest,
  handleCountChange,
  count,
  isAdding,
}: Props) {
  return (
    <>
      <ButtonTableTd>
        <CartWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={1}
            marginToUnits={0}
            marginRight={rem(16)}
          />
          <ButtonWithRequest
            onButtonClick={addToCart}
            onRequestClick={addToRequest}
            noStock={false}
            isAddingToCart={isAdding}
          />
        </CartWrapper>
      </ButtonTableTd>
    </>
  );
}

const CartWrapper = styled(FlexRowCenterVertical)`
  justify-content: flex-end;
`;

const ButtonTableTd = styled(TableTd)`
  /* padding: ${rem(24)} 0 ${rem(16)}; */
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const CountTableTd = styled(TableTd)`
  display: flex;
  justify-content: flex-end;
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

export { ProductPriceCartTable };
